import React, { useMemo, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import * as XLSX from "xlsx";
import Button from "../../components/utils/Button";
import Table from "../../components/utils/Table";
import Modal from "../../components/utils/Modal";
import CardLayout from "../../components/utils/CardLayout";
import { useDispatch, useSelector } from "react-redux";
import reportActions from "../../redux/reports/actions";
import genericActions from "../../redux/generic/actions";
import { downloadExcelSampleFile } from "../../helpers/commonFunction";
import QRCode from "react-qr-code";
const { getACode } = genericActions;
const { getactivationBatchReports, resetMessage } = reportActions;

const ActivationBatchDetails = ({ selectedBatchId, onBack }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const { aCodeList } = useSelector(state => state.generic);
    const [searchItem, setSearchItem] = useState("");
    const [showQRModal, setShowQRModal] = useState(false);
    const [selectedQrData, setSelectedQrData] = useState({});
    const today = new Date();
    const beforeTwoDays = new Date();
    beforeTwoDays.setDate(beforeTwoDays.getDate() - 2);
    const formatDate = (date) => date.toISOString().split("T")[0];
    const { activationBatchReports, activationBatchReportsLoading, } = useSelector((state) => state.reports)
    const { defaultCurrency } = useSelector((state) => state.auth);

    const { register, handleSubmit, reset, formState: { errors } } = useForm({
        mode: "onChange",
        defaultValues: {
            batchID: "",
            isBatchDetail: true,
        },
    });

    useEffect(() => {
        if (selectedBatchId) {
            dispatch(getactivationBatchReports({
                batchID: selectedBatchId,
                isBatchDetail: true,
            }));
        }
    }, [selectedBatchId]);

    const handleQRClick = (data) => {
        console.log("data", data);
        setSelectedQrData(data);
        setShowQRModal(true);
    };
      const handleCloseQR = () => {
    setShowQRModal(false);
    setSelectedQrData({});
  };

    const columns = [
        { displayName: "Type", key: "TxnType" },
        { displayName: "Batch ID", key: "BATCHID" },
        { displayName: "Txn ID", key: "TXNID" },
        { displayName: "Serial Number", key: "SERIALNUMBER" },
        { displayName: "MSISDN", key: "MSISDN" },
        { displayName: "Status", key: "STATUS" },
        { displayName: "Description", key: "DESCRIPTION" },
        { displayName: "Month", key: "MONTHTEXT" },
        { displayName: "Remarks", key: "Remarks" },
        { displayName: "ZipCode", key: "ZipCode" },
        { displayName: "Account Balance", key: "AccountBalance" },
        { displayName: "QR Code", key: "LPA" },
        { displayName: "Account Number", key: "AccountNumber" },
        { displayName: "PIN", key: "PIN" },
    ];

    const filteredItems = useMemo(() => {
        return Array.isArray(activationBatchReports) && activationBatchReports.length > 0
            ? activationBatchReports.filter(item => {
                if (!searchItem) return true;
                return Object.values(item).some(val => typeof val === "string" && val.toLowerCase().includes(searchItem.toLowerCase()));
            })
            : [];
    }, [activationBatchReports, searchItem]);

    const rowData = useMemo(() => {
        return (filteredItems || []).map((item) => ({
            TxnType: item?.TxnType == 26 ? 'eSIM' : 'pSIM',
            BATCHID: item?.BatchID,
            TXNID: item?.TransactionID,
            SERIALNUMBER: item?.SERIALNUMBER,
            MSISDN: item?.MobileNumber,
            STATUS: item?.Status,
            DESCRIPTION: item?.Description,
            MONTHTEXT: item?.Month,
            Remarks: item?.Remarks,
            ZipCode: item?.ZipCode,
            AccountBalance: item?.AccountBalance,
            LPA: <div style={{ display: "flex", justifyContent: "center", cursor: "pointer", }} onClick={() => handleQRClick(item)}> <QRCode value={item["LPA"]} size={25} /> </div> || "-",
            AccountNumber: item?.AccountNumber,
            PIN: item?.PIN,

        }));
    }, [filteredItems]);

    const handleBack = () => {
        onBack();
    }

    const handleExportExcel = () => {
        const data = filteredItems.map(item => ({
            "Type": item?.TxnType == 26 ? 'eSIM' : 'pSIM',
            "Batch ID": item["BatchID"],
            "Txn ID": item["TransactionID"],
            "Serial Number": item["SERIALNUMBER"],
            "MSISDN": item["MobileNumber"],
            "Status": item["Status"],
            "Description": item["Description"],
            "Month": item["Month"],
            "Remarks": item["Remarks"],
            "ZipCode": item["ZipCode"],
            "Account Balance": item["AccountBalance"],
            "LPA": item["LPA"],
            "Account Number": item["AccountNumber"],
            "PIN": item["PIN"],
        }));

        downloadExcelSampleFile(data, "activation-batch-detail.xlsx");
    };

    return (
        <CardLayout
            title={<> Activation Batch Details<span style={{ color: "#4b9b60" }}> :#{selectedBatchId}
            </span>
            </>
            }
            icon="ri-file-chart-line "
            rightContent={
                <div className="d-flex gap-2">
                    <Button
                        title="Back"
                        buttonType="button"
                        icon={<i className="ri-arrow-left-line me-1" />}
                        variant="primary"
                        style={{
                            padding: "5px 10px",
                        }}
                        onClick={() => handleBack()}
                    />
                    <Button
                        title="Excel"
                        buttonType="button"
                        variant="secondary"
                        onClick={handleExportExcel}
                        icon={<i className="ri-download-cloud-line me-2" />}
                    />
                </div>
            }
        >
            <div className="col-lg-3 offset-lg-9 col-md-4 d-flex align-items-end" >
                <input
                    type="search"
                    onChange={(e) => setSearchItem(e.target.value)}
                    className="form-control form-control-sm"
                    placeholder="Search..."
                />
            </div>
            {/* Table */}
            <div className="mt-2">
                <Table
                    columns={columns}
                    data={rowData}
                    pagination
                    loading={activationBatchReportsLoading}
                    tableHeight="270px"
                />
            </div>
            <Modal
                title={selectedQrData?.TransactionID || 'QR Code'}
                showModal={showQRModal}
                onHide={handleCloseQR}
                showFooter={false}
                width={320}
            >
                <div className="d-flex justify-content-center py-3">
                    <div
                        className="p-3"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            borderRadius: "15px",
                            boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                        }}
                    >
                        {selectedQrData?.LPA && (
                            <QRCode
                                value={selectedQrData?.LPA}
                                size={180}
                            />
                        )}
                    </div>
                </div>
            </Modal>
        </CardLayout>

    );
};

export default ActivationBatchDetails;

